module.exports = __webpack_public_path__ + "static/media/WAF_Protest_General.45db3866.jpg";